// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"269c2758","453":"2f6c0cf7","455":"86347992","977":"4b1ef03e"}[chunkId] + ".chunk.js";
};